import React from 'react';

import loading from 'assets/images/svg/loading.svg';

import styles from './Loader.module.scss';

// <Loader size={'small'} overlay={false} /> - для создания маленького слайдера

type LoaderProps = {
  size?: 'small' | 'large';
  overlay?: boolean;
};

export const Loader: React.FC<LoaderProps> = ({ size = 'large', overlay = true }) => {
  const loaderElement = (
    <div
      className={`${styles.wrapper} ${size === 'small' ? styles.small : styles.large} ${
        overlay ? styles.overlay : ''
      }`}
    >
      <img src={loading} alt="Loading..." className={styles.image} />
    </div>
  );

  if (overlay) {
    return <div className={styles.overlay}>{loaderElement}</div>;
  }

  return loaderElement;
};
